import { render } from "./profilePhone.vue?vue&type=template&id=17bb7fa4&scoped=true&ts=true"
import script from "./profilePhone.vue?vue&type=script&lang=ts"
export * from "./profilePhone.vue?vue&type=script&lang=ts"

import "./profilePhone.vue?vue&type=style&index=0&id=17bb7fa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bb7fa4"]])

export default __exports__